import { render, staticRenderFns } from "./order-create.vue?vue&type=template&id=3efd5a60&scoped=true"
import script from "./order-create.vue?vue&type=script&lang=js"
export * from "./order-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd5a60",
  null
  
)

export default component.exports